<template>
    <div class="terms-wrapper">
        <app-header-mini :img="'/static/img/terms/header.jpg'"></app-header-mini>
        <div class="terms-content">
            <h1 class="indent">Termini e condizioni d’uso</h1>
          <p class="indent">Questo sito è proprietà di <span class="strong">Alcomet AD</span>. Continuando la navigazione del sito, si accettano i termini e le condizioni di uso.</p>
            <p class="indent">È possibile utilizzare le informazioni qui presenti solamente per facilitare le vostre relazioni ed i vostri rapporti d’affari con Alcomet.</p>
            <p class="indent">Non è consentito modificare, copiare, pubblicare e/o diffondere, neanche parzialmente, i contenuti di questo sito web o violare in altro modo i diritti d'autore su testi, dati, foto e qualsiasi altra informazione pubblicata su questo sito web.</p>
            <p class="indent">ALCOMET AD si riserva il diritto di modificare i contenuti di questo sito web e di sospenderne l'accesso in qualsiasi momento e senza preavviso agli utenti del sito web. Lo scopo di questo sito web e dei suoi contenuti è quello di garantire la vostra facilità d’uso. ALCOMET AD non garantisce che il sito web sia privo di errori e che l'accesso al sito web sia ininterrotto. Non ci assumiamo alcuna responsabilità per qualsiasi perdita di informazioni dovuta al ricaricamento o alla copia di materiali, immagini, testi o altre informazioni incluse nei suoi contenuti.</p>
            <p class="indent">Tutti i marchi commerciali, il logo e gli elementi chiave dell'identità aziendale di ALCOMET AD sono registrati come marchi di servizio e protetti dalle leggi della Repubblica di Bulgaria e dalle norme internazionali</p>
            <p class="indent">Tutti i materiali contenuti in questo sito web sono protetti dalla legge sul diritto d'autore.</p>
            <p class="indent">Richieste ed offerte inviate ad ALCOMET AD attraverso questo sito web rappresentano richieste preliminari per ottenere informazioni. Per richieste e impegni particolari, si prega di contattare il personale competente specificato.</p>
            <p class="indent">Nell'esercizio della propria attività, ALCOMET AD rispetta le disposizioni della legge sull'offerta pubblica di titoli e del relativo regolamento di attuazione, la legge sul commercio, la legge sulla contabilità, la legge sul diritto d'autore, la legge sul controllo finanziario indipendente, la legge sull'audit interno, la legge sugli abusi di mercato con strumenti finanziari, i principi contabili nazionali e internazionali, i principi internazionali di buona governance aziendale, il codice del lavoro, il codice nazionale di governo societario, ecc</p>
        </div>
    </div>
</template>

<script>
import HeaderMini from "./shared/HeaderMini";
export default {
  components: {
    appHeaderMini: HeaderMini
  }
};
</script>

<style scoped>
.terms-content {
  padding: 0 0 60px;
}
.terms-content > h1 {
  font-size: 34px;
  font-weight: 500;
  margin: 0 auto 25px;
  width: 800px;
}
.terms-content > p {
  font-size: 19px;
  text-align: justify;
  line-height: 32px;
  margin: 15px auto;
  width: 800px;
}
@media screen and (max-width: 1000px) {
  .terms-content > h1 {
    font-size: 20px;
    padding: 0 30px;
    width: 100%;
  }
  .terms-content > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Terms.vue